import React from 'react';

import useReachableUsers from 'hooks/audiences/useReachableUsers';

import { FormulaDetailModel } from 'models/formula.model';

import { SummaryItem } from './SummaryItem';

export const ReachableUsersSummary = ({
    formula,
}: {
    formula: FormulaDetailModel;
}) => {
    const { data: reachableUsers } = useReachableUsers(formula);
    const count = reachableUsers?.total_filtered_audience || 0;
    return <SummaryItem label="Reachable Users" value={count} />;
};
